window.o_global = window.o_global || {};

/**
 * Handle global "debug mode" by setting a cookie.
 *
 * @return {Object} Public API of o_global.debug
 */
o_global.debug = (function() {
    "use strict";

    var statusObject = {};

    /**
     * Check if debug cookie was set.
     * Returns updated statusObject
     *
     * @return {Object} Object holding status information of debug mode.
     */
    function status() {
        if (document.cookie.match(/debug=true/i)) {
            statusObject = {
                "activated": true,
                "text": "activated"
            };
        } else {
            statusObject = {
                "activated": false,
                "text": "deactivated"
            };
        }

        return statusObject;
    }

    /**
     * Activate "debug mode" by setting a cookie.
     *
     * @return {String} Status string.
     */
    function activate() {
        if (!status().activated) {
            document.cookie = "debug=true";
        }

        return status().text;
    }

    /**
     * Deactivate "debug mode" by deleting the debug cookie.
     *
     * @return {String} Status string.
     */
    function deactivate() {
        if (status().activated) {
            document.cookie = "debug=; expires=" + new Date().toGMTString();
        }

        return status().text;
    }

    /**
     * Function to print warning.
     *
     * @param {String} message  Warning message.
     */
    function warn(message) {
        if (status().activated) {
            console.warn(message);
        }
    }

    /**
     * Public methods.
     */
    return {
        "activate": activate,
        "deactivate": deactivate,
        "status": status,
        "warn": warn
    };
}());
